export const WHATS_NEW_ITEMS_LIST = 'whatsNewItemsList';
